import {Pipe, PipeTransform} from '@angular/core';
import {FieldDto} from '../../../Models/Tasks/General/task.interface';

@Pipe({
  name: 'platforms',
  standalone: false
})
export class PlatformsPipe implements PipeTransform {

  transform(items: FieldDto[], platform?: number): FieldDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (platform) {
      items = items.filter((item) => item.id_plataforma === platform);
    }

    return items;

  }

}
